/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Voyager API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  PostV1AuthMe200,
  PostV1AuthMe400,
  PostV1AuthMe500
} from '../../schemas';

import { fetcher } from '../../../lib/api-client.ts';
import type { ErrorType } from '../../../lib/api-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get the current user
 */
export const postV1AuthMe = (

 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {


      return fetcher<PostV1AuthMe200>(
      {url: `/v1/auth/me`, method: 'POST', signal
    },
      options);
    }




export const getPostV1AuthMeMutationKey = () => ['postV1AuthMe'] as const;

export const getPostV1AuthMeMutationOptions = <TError = ErrorType<PostV1AuthMe400 | PostV1AuthMe500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1AuthMe>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof postV1AuthMe>>, TError,void, TContext> => {

const mutationKey = getPostV1AuthMeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postV1AuthMe>>, void> = () => {


          return  postV1AuthMe(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostV1AuthMeMutationResult = NonNullable<Awaited<ReturnType<typeof postV1AuthMe>>>

    export type PostV1AuthMeMutationError = ErrorType<PostV1AuthMe400 | PostV1AuthMe500>


    export const usePostV1AuthMe = <TError = ErrorType<PostV1AuthMe400 | PostV1AuthMe500>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postV1AuthMe>>, TError,void, TContext>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postV1AuthMe>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getPostV1AuthMeMutationOptions(options), queryClient);
    }
